module.exports = __webpack_public_path__ + "static/media/1-4.d39c2f9c.png";